import { withAsyncLoading } from '../../../Components/Templates/Loading/AsyncPageLoading/withAsyncPageLoading';

const LoadableCauserieDetailsPage = withAsyncLoading(async () =>
    import('./CauserieDetailsPage').then((res) => res.CauserieDetailsPage)
);

export { LoadableCauserieDetailsPage };
